function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { stackFromColorKeys } from "./utils";
export var genSurfaceContextFn = function(param) {
    var key = param.key, backgroundColor = param.backgroundColor;
    return function(theme) {
        return _objectSpread({}, theme, {
            backgroundColor: _objectSpread({}, theme.backgroundColor, _defineProperty({}, key, _objectSpread({}, stackFromColorKeys(backgroundColor, theme))))
        });
    };
};
